// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-scheduling-wrapper {
    padding: 1rem;
    background-color: #f9f9f9;
    border-radius: 8px;
    min-height: 100%;
  }
  
  .toggle-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
  }
  
  .toggle-button {
    background-color: var(--clr-primary-5);
    color: #fff;
    padding: 0.5rem 1.25rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.95rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: background-color 0.2s ease, transform 0.2s ease;
  }
  
  .toggle-button:hover {
    background-color: var(--clr-primary-4);;
    transform: translateY(-1px);
  }
  
  .scheduling-body {
    border: 1px solid #e0e0e0;
    background-color: #ffffff;
    /* padding: 1.25rem; */
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
  `, "",{"version":3,"sources":["webpack://./src/components/AdminSchedulingToggleWrapper/AdminSchedulingWrapper.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;IACtC,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,2DAA2D;EAC7D;;EAEA;IACE,sCAAsC;IACtC,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;EAC3C","sourcesContent":[".admin-scheduling-wrapper {\n    padding: 1rem;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    min-height: 100%;\n  }\n  \n  .toggle-header {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 1rem;\n  }\n  \n  .toggle-button {\n    background-color: var(--clr-primary-5);\n    color: #fff;\n    padding: 0.5rem 1.25rem;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 0.95rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: background-color 0.2s ease, transform 0.2s ease;\n  }\n  \n  .toggle-button:hover {\n    background-color: var(--clr-primary-4);;\n    transform: translateY(-1px);\n  }\n  \n  .scheduling-body {\n    border: 1px solid #e0e0e0;\n    background-color: #ffffff;\n    /* padding: 1.25rem; */\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
